import './Especialidades.css'
import CardMUI from './CardMUI'

function Especialidades(){
    return(
        <div className='Esp-main'>
            <h2 class="Esp-text1">Principais Especialidades</h2>
            <div className='Esp-card'>
                <CardMUI texto1="Esteatose hepática"/>
                <CardMUI texto1="Nódulos no fígado"/>
                <CardMUI texto1="Cirrose hepática"/>
                <CardMUI texto1="Gastrite"/>
                <CardMUI texto1="Diarreia"/>
                <CardMUI texto1="Constipação crônica"/>
            </div>

        
        </div>
    )
}
export default Especialidades